module.exports = __webpack_public_path__ + "static/2-eb792f3296ed8bfb498fa04554ecbfa6.jpg";